import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import FileIcon from "../../custom/FileIcon";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import $, { error } from "jquery";
import API from "../../helpers/endpointservice";
import axios from "axios";
import WarningComponent from "../../helpers/modal";
import { toast } from "react-toastify";
import Toaster from "../../helpers/toaster";
import CommonIcon from "../../helpers/icons";
import PaginationComponent from "../../helpers/Pagination";
import moment from "moment";
import UserRole from "../../helpers/role";
import UserStatus from "../../helpers/status";
import Loader from "../../helpers/loader";
import DateFnsUtils from "@date-io/date-fns";
import Select from "react-select";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  }),
};

class RequestStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      sortBy: "trainingRequestId",
      isSortAscending: true,
      currentUser: "",
      isNext: false,
      isAgree: false,
      isDontAgree: false,
      isSubmissionFailed: false,
      isSubmissionLoader: false,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      isSMobile: false,
      uploadedFileName: "",
      pendingId: 0,
      trainingRequestId: 0,
      checkDocument: "",
      pendingStatus: "",
      // pendingApprovalsList: [],
      CancelRequestComments: "",
      pageNewCount: false,
      pendingApprovalsView: {
        id: 0,
        courseCode: "",
        courseTitle: "",
        currentStatus: "",
        employeeCode: null,
        employeeGuid: null,
        employeeName: "",
        employeeuserId: 0,
        requestedBy: null,
        requestedDate: null,
        startDate: null,
        endDate: null,
        trainingRequestId: 0,
        status: "",
        statusId: 0,
        comments: "",
        fileUrl: "",
        trainingBond: {
          fileId: 0,
          fileName: "",
        },
        certificate: {
          fileId: 0,
          fileName: "",
        },
        trainingStatusId: 0,
        trainingRequestorId: 0,
      },
      searchInputData: {
        trainingRequestId: "",
        requestedfor: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        startDate: null,
        endDate: null,
        currentStatus: "",
        trainingBondStatus: "",
        certificateStatus: "",
        louStatus: "",
        courseQuestionnaireStatus: "",
        pteStatus: "",
      },
      validationMsg: false,
      isSearch: false,
      employeeNameEmpty: false,
      selectEmployeeName: [],
      employeeNameList: [],
      currentPage: 1,
      pageCount: 0,
      perPage: 20,
      requestCount: 0,
      historyLogList: [],
      validateComments: false,
      UserId: 0,
      isView: true,
      isLou: false,
      isPte: false,
      isCourse: false,
      PTE: [],
      pteAnswersOption: [],
      pteJobAnswerOption: [],
      pteJob: [],
      courseAdd: [],
      CourseQuestAnswers: [],
      LouDetails: {},
      LouAnswers: {},
      pendingApprovalsList1: {},
      currentStatusList: [],
      currentStatus: [],
      louStatus: [],
      louStatusList: [],
      trainingBondStatus: [],
      trainingBondstatusList: [],
      pteStatus: [],
      pteStatusList: [],
      certificateStatus: [],
      certificateStatusList: [],
      courseQuestionnaireStatus: [],
      cqStatusList: [],
    };
    this.focusRef = React.createRef();
  }
  componentDidMount() {
    let user = localStorage.getItem("UserId");
    // let value = localStorage.getItem("Role");
    this.state.UserId = user;
    let userrole = localStorage.getItem("Role");
    this.state.currentUser = userrole?.split(",")[0];
    this.setState({}, () => {
      this.MyRequestStatusList();
    });
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
    this.getCourseQuestAnswers();
    this.getPteAnswerOptions();
    this.getPteJobAnswerOptions();
    this.getCurrentStatus();
  }

  getCurrentStatus = () => {
    let apiUrl = `${API.GET_CURRENT_STATUS}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.currentStatusList = res?.data?.currentStatus?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );

          this.state.louStatusList = res?.data?.lou?.map((status) => {
            return {
              value: status,
              label: (
                <>
                  <span>{status}</span>
                </>
              ),
            };
          });

          this.state.trainingBondstatusList = res?.data?.trainingBond?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );

          this.state.cqStatusList = res?.data?.courseQuestionnaire?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );

          this.state.pteStatusList = res?.data?.pte?.map((status) => {
            return {
              value: status,
              label: (
                <>
                  <span>{status}</span>
                </>
              ),
            };
          });

          this.state.certificateStatusList = res?.data?.certificate?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }
    if (window.innerWidth < 300 && window.innerWidth > 399) {
      this.state.isSMobile = true;
    } else {
      this.state.isSMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  getCourseQuestAnswers = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_COURSE_QUEST_ANSWERS).then((res) => {
      if (res.status === 200) {
        const evaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));

        this.state.CourseQuestAnswers = evaluationAns;
        this.setState({});
      }
    });
  };

  getPteAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_EVAL_ANS).then((res) => {
      if (res.status === 200) {
        const pteEvaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        this.state.pteAnswersOption = pteEvaluationAns;
        this.setState({});
      }
    });
  };

  getPteJobAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_SKILL_STATUS).then((res) => {
      if (res.status === 200) {
        const pteJobEvaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        this.state.pteJobAnswerOption = pteJobEvaluationAns;
        this.setState({});
      }
    });
  };

  MyRequestStatusList = () => {
    // this.state.pendingApprovalsList = this.state.pendingApprovalsList1?.values;
    const { sortBy, UserId, isSearch, searchInputData, currentPage, perPage } =
      this.state;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_REQUEST_STATUS
      }?sortBy=${sortBy}&isSortAscending=${order}&userId=${UserId}&pageNumber=${parseInt(
        currentPage
      )}&pageSize=${parseInt(perPage)}`;
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
      perPage: perPage,
    });
    let searchValues = {
      requestId: searchInputData.trainingRequestId || null,
      requestedFor: searchInputData.requestedfor || null,
      courseCode: searchInputData.courseCode || null,
      courseTitle: searchInputData.courseTitle || null,
      currentStatus: searchInputData.currentStatus || null,
      requestedDate:
        searchInputData.requestedDate?.toISOString()?.slice(0, 10) || null,
      trainingBondStatus: searchInputData.trainingBondStatus || null,
      certificateStatus: searchInputData.certificateStatus || null,
      louStatus: searchInputData.louStatus || null,
      courseQuestionnaireStatus:
        searchInputData.courseQuestionnaireStatus || null,
      pteStatus: searchInputData.pteStatus || null,
      startDate: searchInputData.startDate?.toISOString()?.slice(0, 10) || null,
      endDate: searchInputData.endDate?.toISOString()?.slice(0, 10) || null,
    };
    axios({
      method: "POST",
      url: apiUrl,
      data: isSearch === true ? searchValues : {},
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            pendingApprovalsList: res.data.values,
            isSubmissionLoader: false,
            isSubmissionFailed: false,
            pageCount: res.data.totalCount,
            currentPage: res.data.currentPage,
            perPage: res.data.pageSize,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isSubmissionLoader: false,
          isSubmissionFailed: false,
          isSearch: false,
        });
        logoutFunction(error?.response?.status);
        // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  fetchPaginationList = (currentPage, perPage) => {
    this.setState(
      {
        currentPage: currentPage,
        perPage: perPage,
        isSortAscending: this.state.isSortAscending,
        sortBy: this.state.sortBy,
      },
      () => {
        this.MyRequestStatusList();
      }
    );
  };

  sortTable = (name) => {
    let sortData = this.state.pendingApprovalsList;
    if (sortData.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      // this.setState({}, () => {
      //   this.MyRequestStatusList()
      // })
      this.state.currentPage = 1;
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({}, () => {
        this.MyRequestStatusList(this.state.currentPage, this.state.perPage);
      });
    }
  };

  MyPendingSubmission = (trainingRequestId, status) => {
    this.state.pendingStatus = status?.toLowerCase()?.replace(/\s+/g, "");
    this.ShowPendingSubmissionById(trainingRequestId);
    this.setState({ trainingRequestId: trainingRequestId });
    // this.propertiesScreen();
    this.GetHistoryLogList(trainingRequestId);
  };

  propertiesScreen = () => {
    $("#myRequestBody").scrollTop(0);
    this.setState({
      isView: true,
      isLou: false,
      isCourse: false,
      isPte: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("cancelrequestScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  getEmployeeName = async () => {
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    const { UserId, employeeNameList } = this.state;
    let apiUrl = `${API.GET_EMPLOYEES}?userId=${UserId}`;
    let res = await this.updateGetFunction(apiUrl);
    if (res.status === 200) {
      this.state.employeeNameList = res?.data?.map((employee) => {
        return {
          value: employee.employeeName,
          label: (
            <>
              <span>{employee.employeeName}</span>
            </>
          ),
        };
      });
      this.setState({
        isSubmissionFailed: false,
        isSubmissionLoader: false,
      });
    }
  };

  getCourseQuestionnaireById = (id) => {
    let apiUrl = `${API.GET_COURSE_QUESTIONAIRE}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.courseAdd = res.data.questions;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getLouById = (id) => {
    let apiUrl = `${API.GET_PENDING_LOU}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.LouDetails = res.data;
          this.state.isRequestLoader = false;
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getPteById = (id) => {
    let apiUrl = `${API.GET_PTE_BY_ID}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.PTE = res.data.pteQuestions;
          this.state.pteJob = res.data.jobQuestions;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  updateGetFunction = async (uri) => {
    try {
      const response = await axios({
        method: "GET",
        url: uri,
      });

      let responseData = {
        ok: true,
        status: 200,
        statusText: "success",
        data: response.data,
        error: undefined,
        type: "retrieve",
        url: uri,
      };

      return responseData;
    } catch (error) {
      let responseData = {
        ok: false,
        status: error.response?.status || 500,
        statusText: error.response?.statusText || "Internal Server Error",
        error: error.response?.data?.message || "Unknown Error",
        type: "retrieve",
        url: uri,
      };
      logoutFunction(error?.response?.status);
      this.setState({ isSubmissionLoader: false });
      swal("Error!", "Something went wrong. Please try again.", "warning");
      return responseData;
    }
  };

  ShowPendingSubmissionById = (trainingRequestId) => {
    this.clearAllData();
    let apiUrl = `${API.GET_TRAINING_REQUEST_ID}?requestId=${trainingRequestId}`;
    this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.pendingApprovalsView.trainingRequestId = res.data.id;
          // this.state.pteStatus = res.data.pteStatus;
          // this.state.louStatus = res.data.louStatus;
          // this.state.cqStatus = res.data.courseQuestionnaireStatus;

          if (res.data?.isPte === true) {
            const pendingStatusPte = res.data?.pteStatus
              ?.toLowerCase()
              ?.replace(/\s+/g, "");
            if (
              //     pendingStatusPte === UserStatus.PTE2_UPDATE ||
              //     pendingStatusPte === UserStatus.PTE3_UPDATE ||
              //     pendingStatusPte === UserStatus.PTE1_REWORK ||
              //     pendingStatusPte === UserStatus.PTE2_REWORK ||
              //     pendingStatusPte === UserStatus.PTE3_REWORK ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE1_APPROVAL ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE2_APPROVAL ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE3_APPROVAL ||
              //     pendingStatusPte === UserStatus.PTE1_UPDATED ||
              //     pendingStatusPte === UserStatus.PTE2_UPDATED ||
              //     pendingStatusPte === UserStatus.PTE3_UPDATED ||
              //     pendingStatusPte === UserStatus.WAITING_FOR_PTE2 ||
              //     pendingStatusPte === UserStatus.WAITING_FOR_PTE3 ||
              //     pendingStatusPte === UserStatus.PTE_COMPLETED
              !pendingStatusPte?.includes(UserStatus.PTE1_UPDATE)
            ) {
              this.getPteById(trainingRequestId);
            } else {
              this.state.PTE = [];
              this.setState({});
            }
          }

          if (res.data?.isLou === true) {
            if (res.data.louStatus?.toLowerCase() === UserStatus.SUBMITTED) {
              this.getLouById(trainingRequestId);
            } else {
              this.state.LouDetails = [];
              this.setState({});
            }
          }

          if (res.data?.isCourseQuestionnaire === true) {
            if (
              res.data.courseQuestionnaireStatus?.toLowerCase() ===
              UserStatus.PENDING_FOR_CQ_REVIEW ||
              res.data.courseQuestionnaireStatus?.toLowerCase() ===
              UserStatus.COMPLETED_STATUS
            ) {
              this.getCourseQuestionnaireById(trainingRequestId);
            } else {
              this.state.courseAdd = [];
              this.setState({});
            }
          }
          this.propertiesScreen();
          this.setState({
            pendingApprovalsView: {
              ...this.state.pendingApprovalsView,
              trainingRequestId: res.data.id,
              trainingBond: {
                fileId: res.data.trainingBond.fileId,
                fileName: res.data.trainingBond.fileName,
              },
              certificate: {
                fileId: res.data.certificate.fileId,
                fileName: res.data.certificate.fileName,
              },
              ...res.data,
            },
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
          
        }
      })
      .catch((error) => {
        console.log(error);
        logoutFunction(error?.response?.status);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  GetHistoryLogList = (trainingRequestId) => {
    let apiUrl = `${API.GET_HISTORY_LOG}?trainingRequestId=${trainingRequestId}`;
    // this.setState({ isSubmissionLoader: true, isSubmissionFailed: false });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status == 200) {
          this.setState({
            historyLogList: res.data
          });
        }
      })
      .catch((error) => {
        console.log(error);
        // this.setState({
        //   isSubmissionLoader: false,
        //   isSubmissionFailed: true,
        // });
        logoutFunction(error?.response?.status);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  handleInputchange(e, field) {
    if (
      field === "requestedDate" ||
      field === "startDate" ||
      field === "endDate"
    ) {
      let reqDate = new Date(e);
      this.state.searchInputData[field] = reqDate;
    } else {
      this.state.searchInputData[field] = e.target.value;
    }
    this.setState({});
  }

  handleTBondComments = (e) => {
    this.setState({
      CancelRequestComments: e.target.value,
    });
  };

  validateSearchRecords = () => {
    const inputs = document.querySelectorAll(
      ".records-editinput-class[required]"
    );
    let isValid4 = false;
    if (this.state.searchInputData.currentStatus || this.state.searchInputData.trainingBondStatus
      || this.state.searchInputData.certificateStatus || this.state.searchInputData.louStatus
      || this.state.searchInputData.courseQuestionnaireStatus || this.state.searchInputData.pteStatus
    ) {
      isValid4 = true;
    } else {
      isValid4 = false;
    }

    const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
    const isValid1 = this.state.searchInputData.requestedDate;
    const isValid2 = this.state.searchInputData.startDate;
    const isValid3 = this.state.searchInputData.endDate;
    if (isValid || isValid1 || isValid2 || isValid3 || isValid4) {
      this.submitSearchDetails();
      this.setState({
        validationMsg: false,
      });
    } else {
      this.setState({
        validationMsg: true,
      });
    }
  };

  submitSearchDetails = () => {
    this.state.isSearch = true;
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState({}, () => this.MyRequestStatusList());
    $("#cancelrequestScreen").removeClass("show");
    $("#searchScreen").addClass("visible-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  openSearch = () => {
    // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("searchScreen"));
    // myOffcanvas.show();
    $("#searchScreen").removeClass("visible-hide");
    $("#searchScreen").addClass("visible-show");
    this.setState({ validationMsg: false });
    $("body").addClass("scrollhide");
    this.getEmployeeName();
  };

  clearSearchDetails = () => {
    this.clearAllData();
    this.setState(
      {
        currentPage: 1,
        pageNewCount: !this.state.pageNewCount,
        isSearch: false,
      },
      () => {
        this.MyRequestStatusList();
      }
    );
    $("#cancelrequestScreen").removeClass("show");
    $("#searchScreen").addClass("visible-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  closeProperties = () => {
    this.setState({
      isPte: false,
      isCourse: false,
      isLou: false,
      isView: true,
      LouDetails: [],
      courseAdd: [],
      PTE: [],
      pteJob: [],
    });
    $("#searchScreen").removeClass("visible-show");
    $("#cancelrequestScreen").removeClass("show");
    $("#searchScreen").addClass("visible-hide");
    $("body").removeClass("scrollhide");
    this.state.order = "asc";
    this.clearAllData();
  };

  handleCancelRquestPopup = () => {
    $("#cancelrequestScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    toast.success("Request cancelled successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  handleRequest = () => {
    if (this.state.CancelRequestComments !== "") {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("CancelCourseScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    } else {
      this.focusRef.current.focus();
      this.setState({
        validateComments: true,
      });
    }
  };

  cancelRequest = () => {
    const { UserId, pendingApprovalsView } = this.state;
    let apiurl = `${API.GET_CANCEL_TRAINING}?userId=${UserId}&trainingRequestId=${pendingApprovalsView.id}&comments=${this.state.CancelRequestComments}`;
    this.setState({
      isSubmissionLoader: true,
      isSubmissionFailed: false,
    });
    axios({
      method: "POST",
      url: apiurl,
    })
      .then((res) => {
        this.setState({
          isSubmissionLoader: true,
          isSubmissionFailed: false,
        });
        if (res.status == 200) {
          this.handleCancelRquestPopup();
          this.MyRequestStatusList();
          this.setState({
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        logoutFunction(error?.response?.status);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
        // toast.error("Failed to cancel request.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
      });
  };

  handleFileClose = () => {
    this.setState({
      uploadedFileName: "",
    });
  };

  handleFilesOpen = (type) => {
    let apiUrl = `${API.GET_FILES_URL}?fileId=${this.state.pendingApprovalsView.trainingBond.fileId}`;
    let certApi = `${API.GET_FILES_URL}?fileId=${this.state.pendingApprovalsView.certificate.fileId}`;
    let trainApi = `${API.GET_FILES_URL}?fileId=${this.state.pendingApprovalsView.trainingBond.fileId}`;
    axios({
      method: "GET",
      url: type === "Certificate" ? certApi : trainApi,
    })
      .then((res) => {
        this.setState({
          isSubmissionLoader: true,
          isSubmissionFailed: false,
        });
        if (res.status === 200) {
          this.setState({
            pendingApprovalsView: {
              ...this.state.pendingApprovalsView,
              fileUrl: res.data,
            },
            isSubmissionLoader: false,
            isSubmissionFailed: false,
          });
          res.data && window.open(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
        logoutFunction(err?.response?.status);
        this.setState({ isSubmissionLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  clearAllData = () => {
    this.setState({
      uploadedFileName: "",
      pendingApprovalsView: {},
      searchInputData: {
        trainingRequestId: "",
        requestedfor: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        startDate: null,
        endDate: null,
        currentStatus: "",
        trainingBondStatus: "",
        certificateStatus: "",
        louStatus: "",
        pteStatus: "",
        courseQuestionnaireStatus: "",
      },
      currentStatus: null,
      trainingBondStatus: null,
      certificateStatus: null,
      louStatus: null,
      courseQuestionnaireStatus: null,
      pteStatus: null,
      isSearch: false,
      employeeNameList: [],
      selectEmployeeName: [],
      CancelRequestComments: "",
      validateComments: false,
    });
  };

  showViewStatus = () => {
    this.state.isSubmissionLoader = true;
    setTimeout(() => {
      this.state.isSubmissionLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: false,
      isCourse: false,
      isView: true,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("cancelrequestScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  showLouStatus = () => {
    this.state.isSubmissionLoader = true;
    setTimeout(() => {
      this.state.isSubmissionLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: true,
      isCourse: false,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("cancelrequestScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  showPteStatus = () => {
    this.state.isSubmissionLoader = true;
    setTimeout(() => {
      this.state.isSubmissionLoader = false;
    }, 1000);
    this.setState({
      isPte: true,
      isLou: false,
      isCourse: false,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("cancelrequestScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  showCourseStatus = () => {
    this.state.isSubmissionLoader = true;
    setTimeout(() => {
      this.state.isSubmissionLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: false,
      isCourse: true,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("cancelrequestScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  handleCurrentStatus = (e) => {
    this.state.currentStatus = e;
    this.state.searchInputData.currentStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeCertificateStatus = (e) => {
    this.state.certificateStatus = e;
    this.state.searchInputData.certificateStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeCqStatus = (e) => {
    this.state.courseQuestionnaireStatus = e;
    this.state.searchInputData.courseQuestionnaireStatus = e?.value
      ? e.value
      : "";
    this.setState({});
  };

  onchangeLouStatus = (e) => {
    this.state.louStatus = e;
    this.state.searchInputData.louStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeTbStatus = (e) => {
    this.state.trainingBondStatus = e;
    this.state.searchInputData.trainingBondStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangePteStatus = (e) => {
    this.state.pteStatus = e;
    this.state.searchInputData.pteStatus = e?.value ? e.value : "";
    this.setState({});
  };

  render() {
    const {
      isMobile,
      iswebMobile,
      isSmallMobile,
      historyLogList,
      pendingApprovalsList,
      pendingStatus,
      currentUser,
      pendingApprovalsView,
      isRadioMobile,
      isSubmissionLoader,
      validateComments,
      CancelRequestComments,
      sortBy,
      order,
      isView,
      isLou,
      isCourse,
      isPte,
      LouDetails,
    } = this.state;
    let { menuToggle } = this.props;
    return (
      <>
        {$("#cancelrequestScreen").hasClass("show") ||
          $("#searchScreen").hasClass("visible-show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div
          className={`${isMobile
            ? "main-body-mobile"
            : menuToggle
              ? "menu-main-body"
              : "main-body"
            } `}
        >
          <Loader isLoader={isSubmissionLoader} />
          <div className="pendingTask-head-fixed">
            {isMobile == true ? (
              <>
                <div className={`p-0 mr-0 w-80 `}>
                  <span
                    className={`mobile-head border-bottom w-100 d-flex justify-content-between`}
                  >
                    <span className="mobile-title">My request status</span>
                    <span onClick={() => this.openSearch()}>
                      <CommonIcon fileName="searchIcon1" />
                    </span>
                  </span>
                </div>
              </>
            ) : (
              <>
                <div
                  className={` ${menuToggle ? "width-100" : "width-filter"
                    } px-4 position-relative border-bottom row `}
                >
                  <div className="col-6 border-none title">
                    <CommonIcon fileName="MyrequestStatusIcon" />
                    <span className="pl-10 head-span">My request status</span>
                  </div>
                  <div className="text-align-end  title border-none display text-16-red mt-3px col-6">
                    <span
                      className="text-20-bold pr-30 cursor-pointer"
                      onClick={() => this.openSearch()}
                    >
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
          <Toaster />
          <div
            className={`${isMobile ? "common-mobiletable-style" : "request-table-style2"
              } table-responsive `}
          >
            <div
              className={`table-fixed-header ${isMobile
                ? "table-scroll-xy-mobile top-105px"
                : menuToggle
                  ? "table-scroll-xy-menutoggle"
                  : "table-scroll-xy"
                } table-list-view-bottom`}
            >
              <table className="table fileListTable2 table-borderless table-hover">
                <thead>
                  <tr>
                    <td></td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("trainingRequestId")}
                    >
                      <span> Request ID </span>
                      {sortBy === "trainingRequestId" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseCode")}
                    >
                      <span> Course code</span>
                      {sortBy === "courseCode" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("courseTitle")}
                    >
                      <span> Course title</span>
                      {sortBy === "courseTitle" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    {this.state.currentUser !== UserRole.EMPLOYEE && (
                      <td
                        className="cursor-pointer"
                        onClick={() => this.sortTable("requestedFor")}
                      >
                        <span> Requested for</span>
                        {sortBy === "requestedFor" && (
                          <CommonIcon
                            fileName={order === "asc" ? "upArrow" : "downArrow"}
                          />
                        )}
                      </td>
                    )}
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("currentStatus")}
                    >
                      <span>Current status</span>
                      {sortBy === "currentStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("louStatus")}
                    >
                      <span>LOU status</span>
                      {sortBy === "louStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("trainingBondStatus")}
                    >
                      <span>Training bond status</span>
                      {sortBy === "trainingBondStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("pteStatus")}
                    >
                      <span>PTE status</span>
                      {sortBy === "pteStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("certificateStatus")}
                    >
                      <span>Certificate status</span>
                      {sortBy === "certificateStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() =>
                        this.sortTable("courseQuestionnaireStatus")
                      }
                    >
                      <span>CQ status</span>
                      {sortBy === "courseQuestionnaireStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("startDate")}
                    >
                      <span>Start date</span>
                      {sortBy === "startDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("endDate")}
                    >
                      <span>End date</span>
                      {sortBy === "endDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      className="cursor-pointer"
                      onClick={() => this.sortTable("requestedDate")}
                    >
                      <span>Requested date</span>
                      {sortBy === "requestedDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {pendingApprovalsList?.length !== 0 ? (
                    pendingApprovalsList?.map((item, index) => (
                      <tr
                        id={"active" + item.id}
                        key={index}
                        className="requestRadioSelect"
                      >
                        <td></td>
                        <td
                          onClick={() =>
                            this.MyPendingSubmission(
                              item.id,
                              item.currentStatus
                            )
                          }
                        >
                          <span>
                            <a className="properties-view cursor-pointer">
                              {item.trainingRequestId
                                ? item.trainingRequestId
                                : "-"}
                            </a>
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>{item.courseCode ? item.courseCode : "-"}</span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.courseTitle ? item.courseTitle : "-"}
                          </span>
                        </td>
                        {this.state.currentUser !== UserRole.EMPLOYEE && (
                          <td className="width-150px">
                            <span>
                              {item.requestedFor ? item.requestedFor : "-"}
                            </span>
                          </td>
                        )}
                        <td className="width-150px">
                          <span style={{ color: item?.currentStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.currentStatus ? item.currentStatus : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.louStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>{item.louStatus ? item.louStatus : "-"}</span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.trainingBondStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.trainingBondStatus
                              ? item.trainingBondStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.pteStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>{item.pteStatus ? item.pteStatus : "-"}</span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.certificateStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.certificateStatus
                              ? item.certificateStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.courseQuestionnaireStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.courseQuestionnaireStatus
                              ? item.courseQuestionnaireStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.trainingStartDate
                              ? moment(
                                new Date(Date.parse(item.trainingStartDate))
                              ).format("DD-MMM-YYYY h:mm A")
                              : ""}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.trainingEndDate
                              ? moment(
                                new Date(Date.parse(item.trainingEndDate))
                              ).format("DD-MMM-YYYY h:mm A")
                              : ""}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.requestedDate
                              ? moment(
                                new Date(Date.parse(item.requestedDate))
                              ).format("DD-MMM-YYYY h:mm A")
                              : ""}
                          </span>
                        </td>
                        {/* <td className="width-10px"></td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={14} className="table-nodata text-center">
                        {"No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`${isMobile
              ? "common-mobilesubmenu mobile-pagination"
              : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
              } pb-2 pt-2`}
          ></div>
        </div>

        <div
          className={` ${isView
            ? "offcanvasStyle"
            : isLou
              ? "offcanvas-lou mt-48"
              : isCourse
                ? "course_questionnaire_add"
                : isPte
                  ? "pte_add"
                  : ""
            } offcanvas  offcanvas-end  `}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="cancelrequestScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3 mt-10"
              }`}
          >
            <h6
              id="offcanvasRightLabel"
              className="modal-title head-span font-weight-bold"
            >
              {pendingApprovalsView.currentStatus
                ? pendingApprovalsView.currentStatus
                : "-"}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : "pr-0"
                }`}
              onClick={() => {
                this.closeProperties();
              }}
            //  data-bs-toggle="modal" data-bs-target="#CancelCourseScreen"
            >
              <CommonIcon
                fileName="CrossIcon"
                className="cursor-pointer app-image-hover"
              />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div
              className={` d-flex text-12-normal pb-2 justify-content-start min-width-heading  `}
            >
              <div
                className={` ${isView ? "border-bottom-red" : "border-bottom"
                  } pb-2  cursor-pointer no-wrap`}
                onClick={() => {
                  this.showViewStatus();
                }}
              >
                <label className="cursor-pointer">
                  {isView == false && <CommonIcon fileName="MyselfIcon" />}
                  {isView == true && <CommonIcon fileName="mySelfIconActive" />}

                  <span className={` ${isView ? "text-color-red" : ""} px-2`}>
                    Details
                  </span>
                </label>
              </div>
              <div
                className={` ${isLou ? "border-bottom-red" : "border-bottom"
                  } pb-2 cursor-pointer px-2`}
                onClick={() => {
                  this.showLouStatus();
                }}
              // onClick={this.showLou}
              >
                <label className="cursor-pointer">
                  {isLou == true && <CommonIcon fileName="louactiveicon" />}
                  {isLou == false && <CommonIcon fileName="louicon" />}
                  <span className={` ${isLou ? "text-color-red" : ""} px-2`}>
                    LOU
                  </span>
                </label>
              </div>

              <div
                className={` ${isCourse ? "border-bottom-red" : "border-bottom"
                  } cursor-pointer pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  this.showCourseStatus();
                }}
              // onClick={this.showCourseQuestionnaire}
              >
                <label className="cursor-pointer">
                  <lable>
                    {isCourse == true && <CommonIcon fileName="cqActiveIcon" />}
                  </lable>
                  {isCourse == false && (
                    <CommonIcon fileName="CourseQuestionIcon" />
                  )}
                  <span className={` ${isCourse ? "text-color-red" : ""} px-2`}>
                    CQ
                  </span>
                </label>
              </div>
              <div
                className={` ${isPte ? "border-bottom-red" : "border-bottom"
                  }   pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  this.showPteStatus();
                }}
              // onClick={this.showPte}
              >
                <label className="cursor-pointer">
                  {isPte == true && <CommonIcon fileName="pteActive" />}
                  {isPte == false && <CommonIcon fileName="pteIcon" />}
                  <span className={` ${isPte ? "text-color-red" : ""} px-2`}>
                    PTE
                  </span>
                </label>
              </div>
              {
                // isMobile == false &&
                <div
                  className={` ${isView && "min-width-editcourse"} ${isLou && "min-width-courseLou"
                    } ${isCourse && "min-width-courseCq"} ${isPte && "min-width-coursePte"
                    } border-bottom`}
                ></div>
              }
            </div>

            {/* //////////////////// Status view ////////////////////// */}

            {isView && (
              <div>
                <div className="row mt-3">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="requestId" />{" "}
                        <span className="pl-5 text-12-bold">Request ID</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.trainingRequestId
                          ? pendingApprovalsView.trainingRequestId
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="ContactPersonIcon" />
                        <span className="pl-5 text-12-bold">Employee name</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.employeeName
                          ? pendingApprovalsView.employeeName
                          : "-"}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="EmployeeCodeIcon" />
                        <span className="pl-5 text-12-bold">Employee code</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.employeeCode
                          ? pendingApprovalsView.employeeCode
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="CourseCodeIcon" />
                        <span className="pl-7 text-12-bold">Course code</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.courseCode
                          ? pendingApprovalsView.courseCode
                          : "-"}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        {/* <CommonIcon fileName="CourseTitleIcon" /> */}
                        <div className="mt-3px">
                          <CommonIcon fileName="CourseTitleIcon" />
                        </div>{" "}
                        <span className="pl-7 text-12-bold">Course title</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.courseTitle
                          ? pendingApprovalsView.courseTitle
                          : "-"}
                      </label>
                    </div>
                  </div>

                  {this.state.currentUser !== UserRole.EMPLOYEE && (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                          }`}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                              }`}
                          >
                            <CommonIcon fileName="RequestedByIcon" />
                            <span className="pl-7 text-12-bold">
                              Requested for
                            </span>
                            &nbsp;
                          </label>
                          <label
                            className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                              }`}
                          >
                            {pendingApprovalsView.requestedBy
                              ? pendingApprovalsView.requestedBy
                              : "-"}
                          </label>
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="DateIcon" />{" "}
                        <span className="pl-5 text-12-bold">Start date</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.trainingStartDate
                          ? moment(
                            pendingApprovalsView.trainingStartDate
                          ).format("DD-MMM-YYYY")
                          : ""}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="DateIcon" />{" "}
                        <span className="pl-5 text-12-bold">End date</span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.trainingEndDate
                          ? moment(pendingApprovalsView.trainingEndDate).format(
                            "DD-MMM-YYYY"
                          )
                          : ""}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="DateIcon" />{" "}
                        <span className="pl-5 text-12-bold">
                          Requested date
                        </span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.requestedDate
                          ? moment(pendingApprovalsView.requestedDate).format(
                            "DD-MMM-YYYY"
                          )
                          : ""}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="PropertiesIcon" />{" "}
                        <span className="pl-5 text-12-bold">
                          Current status
                        </span>
                      </label>
                      <label
                        className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {pendingApprovalsView.currentStatus || "-"}
                      </label>
                    </div>
                  </div>

                  <>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                        } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            fileName="trainingbondicon"
                            className="properties-img"
                          />
                          <span className="pl-10 text-12-bold">
                            Training bond
                          </span>
                        </label>
                        {pendingApprovalsView.trainingBond ? (
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                            <a
                              className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                }`}
                              onClick={() =>
                                this.handleFilesOpen("TrainingBond")
                              }
                              target="_blank"
                            >
                              <FileIcon
                                fileName={
                                  pendingApprovalsView.trainingBond.fileName
                                }
                                className="documentFile"
                              />
                              <span className="pl-7 text-center urlspan">
                                {pendingApprovalsView.trainingBond.fileName
                                  ? pendingApprovalsView.trainingBond.fileName
                                  : "-"}
                              </span>
                            </a>
                          </div>
                        ) : (
                          <>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                              <label className="table-noversion"> - </label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                        } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            fileName="trainingbondicon"
                            className="properties-img"
                          />
                          <span className="pl-10 text-12-bold">
                            Training bond status
                          </span>
                        </label>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                          <label className="text-12-normal-400">
                            {pendingApprovalsView.trainingBondStatus
                              ? pendingApprovalsView.trainingBondStatus
                              : "-"}{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="certificateCourseCatalogue"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">Certificate</span>
                      </label>
                      {pendingApprovalsView.certificate ? (
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                          <a
                            className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                              }`}
                            onClick={() => this.handleFilesOpen("Certificate")}
                            target="_blank"
                          >
                            <FileIcon
                              fileName={
                                pendingApprovalsView.certificate.fileName
                              }
                              className="documentFile"
                            />
                            <span className="pl-7 text-center urlspan">
                              {pendingApprovalsView.certificate.fileName
                                ? pendingApprovalsView.certificate.fileName
                                : "-"}
                            </span>
                          </a>
                        </div>
                      ) : (
                        <>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
                            <label className="table-noversion"> - </label>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="certificateCourseCatalogue"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">
                          Certificate status
                        </span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingApprovalsView.certificateStatus
                            ? pendingApprovalsView.certificateStatus
                            : "-"}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="louicon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">LOU status</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingApprovalsView.louStatus
                            ? pendingApprovalsView.louStatus
                            : "-"}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="CourseQuestionIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">CQ status</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingApprovalsView.courseQuestionnaireStatus
                            ? pendingApprovalsView.courseQuestionnaireStatus
                            : "-"}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="pteIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">PTE status</span>
                      </label>
                      <div>
                        <span className="text-12-normal-400">
                          {pendingApprovalsView.pteStatus
                            ? pendingApprovalsView.pteStatus
                            : "-"}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                  {pendingStatus?.toLowerCase()?.replace(/\s+/g, "") ===
                    UserStatus.PENDING_FOR_CERT && (
                      <>
                        <div
                          className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"
                            } `}
                        >
                          <div className="form-group">
                            <label
                              className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                                }`}
                            >
                              <CommonIcon fileName="DateIcon" />
                              <span className="pl-5 text-12-bold">
                                Expiry date
                              </span>
                            </label>
                            <label
                              className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                                }`}
                            >
                              {pendingApprovalsView.certificateExpiryDate
                                ? moment(
                                  pendingApprovalsView.certificateExpiryDate
                                ).format("DD-MMM-YYYY")
                                : ""}
                            </label>
                          </div>
                        </div>
                      </>
                    )}
                  {pendingStatus === UserStatus.TRAINING_COMPLETED ||
                    pendingStatus === UserStatus.TRAINING_CANCELLED ||
                    pendingStatus === UserStatus.TRAINING_REJECTED ||
                    currentUser === UserRole.SUPERVISOR ||
                    currentUser === UserRole.EMPLOYEE ||
                    currentUser === UserRole.MANAGER ||
                    currentUser === UserRole.GM ? (
                    <></>
                  ) : (
                    <div
                      className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pb-3 mt-1`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="CommentIcon" />
                          <span className="pl-5 text-12-bold">Comments</span>
                        </label>
                        <textarea
                          className={`form-control border-radius shiptype-select mt-2 comments-style text-12-bold`}
                          onChange={this.handleTBondComments}
                          style={{
                            borderColor: validateComments ? "#d12232" : "",
                          }}
                          value={CancelRequestComments}
                          ref={this.focusRef}
                        />
                      </div>
                    </div>
                  )}
                  {pendingStatus === UserStatus.TRAINING_COMPLETED ||
                    pendingStatus === UserStatus.TRAINING_CANCELLED ||
                    pendingStatus === UserStatus.TRAINING_REJECTED ||
                    currentUser === UserRole.SUPERVISOR ||
                    currentUser === UserRole.EMPLOYEE ||
                    currentUser === UserRole.MANAGER ||
                    currentUser === UserRole.GM ? (
                    <></>
                  ) : (
                    <div
                      className={`${iswebMobile ? "col-12" : "col-6"
                        } col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-3  ${isMobile ? "mt-4" : "mt-2"
                        }`}
                    >
                      <button
                        className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`}
                        onClick={this.handleRequest}
                      >
                        <CommonIcon
                          fileName="ButtonRejectIcon"
                          className="modal-img"
                        />
                        <span className="send-rework-label pl-5">
                          Cancel request
                        </span>
                      </button>
                    </div>
                  )}
                </div>

                {/* ///////////////// History log /////////////////////// */}

                {this.state.currentUser !== UserRole.EMPLOYEE && (
                  <div className="row mt-1">
                    <div
                      className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="VersionIcon" />
                          <span className="pl-5 properties-span">
                            History log
                          </span>
                        </label>
                        <div className="table-responsive table-responsive-scroll mb-4 mt-3">
                          <table id="historyTable">
                            <tbody>
                              {historyLogList.length !== 0 ? (
                                historyLogList.map((i, index) => (
                                  <>
                                    <tr id={index} key={index}>
                                      <td className="title-width fw-bold">
                                        {i.status}
                                      </td>
                                      <td
                                        className={`history-date no-wrap ${isRadioMobile ? "date-width" : ""
                                          }`}
                                      >
                                        {i.createdDate
                                          ? moment(
                                            new Date(
                                              Date.parse(i.createdDate)
                                            )
                                          ).format("DD-MMM-YYYY h:mm A")
                                          : ""}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan={2} className="fw-bold">
                                        {" "}
                                        {i.reviewer}
                                      </td>
                                      {/* Reviewer ----- > type doubt*/}
                                    </tr>
                                    <tr>
                                      <td
                                        colSpan={2}
                                        className="history-comment"
                                      >
                                        {i.comments}
                                      </td>
                                    </tr>
                                  </>
                                ))
                              ) : (
                                <tr>
                                  <td className="table-noversion" colSpan={3}>
                                    No history log to display
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* /////////////////////////// Lou View /////////////////////// */}

            {isLou && (
              <div className="row mt-3">
                <div className="mt-2 scroll">
                  {LouDetails?.questions?.length > 0 ? (
                    LouDetails?.questions?.map((item, questionIndex) => (
                      <div
                        className="text-12-normal-400 d-flex pb-2"
                        key={questionIndex}
                      >
                        {item?.question?.includes("textbox") ? (
                          <>
                            <div className="fw-bold no-wrap">
                              {questionIndex + 1}
                              {" . "}
                            </div>
                            <p className="pl-5 pr-2 lh-base">
                              {item?.question
                                ?.split("textbox")
                                ?.map((part, partIndex) => (
                                  <React.Fragment key={partIndex}>
                                    {partIndex > 0 && (
                                      <span className="lou-min-width border-bottom pl-10 pr-10">
                                        {
                                          item?.answer?.split("&*&")[
                                          partIndex - 1
                                          ]
                                        }
                                        {/* <input
                                        className="form-control height-18 remove-border LOUID color-white"
                                        name="louName"
                                        value={item?.answer?.split(",")[partIndex - 1]}
                                        disabled={true}
                                      /> */}
                                      </span>
                                    )}
                                    <>
                                      <span
                                        className="word-css"
                                        dangerouslySetInnerHTML={{
                                          __html: part
                                            ? part.replace(/\n/g, "<br>")
                                            : "",
                                        }}
                                      ></span>
                                    </>
                                  </React.Fragment>
                                ))}
                            </p>
                          </>
                        ) : (
                          <p className="pl-zero pr-2 pt-2 lh-base">
                            <span className="fw-bold no-wrap">
                              {questionIndex + 1}
                              {" . "}
                            </span>
                            <span
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: item.question
                                  ? item.question.replace(/\n/g, "<br>")
                                  : "",
                              }}
                            ></span>
                          </p>
                        )}
                      </div>
                    ))
                  ) : (
                    <>
                      <div className="text-center">
                        <label className="text-16-normal fw-bold text-color-red">
                          {this.state.pendingApprovalsView.louStatus?.toLowerCase() ===
                            "lou not applicable"
                            ? "LOU is not applicable for this training."
                            : "LOU is not submitted for this training."}
                        </label>
                      </div>
                    </>
                  )}
                  <div>
                    {LouDetails?.questions?.length > 0 && (
                      <>
                        <div className="text-12-normal-400 mt-3">
                          <div className="mt-2">
                            <input
                              type="radio"
                              name="terms"
                              value="1"
                              disabled
                              checked={LouDetails?.isAgree == true}
                            />
                            <span className="mx-3">I agree</span>
                          </div>
                          <div className="mt-2">
                            <input
                              type="radio"
                              name="terms"
                              value="1"
                              disabled
                              checked={LouDetails?.isAgree == false}
                            />
                            <span className="mx-3">I don't agree</span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* ////////////   Course Questionnaire View //////////////// */}

            {isCourse && (
              <div>
                <div className="row ">
                  {this.state.courseAdd?.length > 0 ? (
                    <>
                      <div className={`col-12 pr-10`}>
                        <div
                          className={`${iswebMobile ? "col-12" : "col-12 pl-0"
                            } col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                            } `}
                        ></div>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"} row  `}>
                        <div
                          className={` table-responsive table-responsive-scroll `}
                        >
                          <table className="course-table-width-course-view ">
                            <>
                              <thead>
                                <tr className="border-top height-course">
                                  <th className="col-1 text-12-bold pt-2 border-right border-left pl-10 pb-20">
                                    <span>S.no</span>
                                  </th>
                                  <th className="col-6 pt-2 text-12-bold cq-box-view border-right border-left pl-10 pb-20">
                                    Question
                                  </th>
                                  <th className="col-5 border-right text-12-bold pt-2 border-left pl-10 pb-20">
                                    Answer
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="border-bottom ">
                                {this.state.courseAdd?.length > 0 ? (
                                  this.state.courseAdd.map((item, index) => (
                                    <>
                                      <tr
                                        key={index}
                                        className={`${this.state.courseAdd?.length !==
                                          index + 1 && "border-bottom"
                                          } `}
                                      >
                                        <td className="col-1 text-12-bold mt-2 border-right border-left pl-10 pb-80 ">
                                          {index + 1}
                                        </td>
                                        <td className="col-6  cq-box-view mt-2 border-right border-left pl-10 pr-10 pb-20 text-12-normal-400">
                                          <textarea
                                            className={`text-wrap color-white form-text-box2 resize-none border-none border-radius-0 w-100`}
                                            rows="3"
                                            value={item?.question}
                                            readOnly={true}
                                            disabled={true}
                                          >
                                            {item?.question}
                                          </textarea>
                                        </td>
                                        <td
                                          className={`col-5 mt-2 pl-10 pb-20 text-wrap border-right text-12-normal-400 ${isMobile
                                            ? "form-control-mobile"
                                            : ""
                                            }`}
                                        >
                                          {this.state.CourseQuestAnswers?.map(
                                            (courseOption) => (
                                              <>
                                                <input
                                                  className={`height ${courseOption?.id ===
                                                    item?.answerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + item.questionId + "cq"}
                                                  disabled={
                                                    courseOption?.id !==
                                                    item?.answerId
                                                  }
                                                  checked={
                                                    courseOption?.id ===
                                                    item?.answerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    } label-text`}
                                                >
                                                  {courseOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                ) : (
                                  <tr>
                                    <td className="border-right border-left"></td>
                                    <td
                                      colSpan={7}
                                      className="table-nodata text-center border-right p-2"
                                    >
                                      {"No record found"}
                                    </td>
                                  </tr>
                                )}

                                <tr className="border-right border-left">
                                  <td></td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <>
                        <div className="text-center mt-3">
                          <label className="text-16-normal align-text-middle fw-bold text-color-red">
                            {this.state.pendingApprovalsView.courseQuestionnaireStatus?.toLowerCase() ===
                              "cq not applicable"
                              ? "CQ is not applicable for this training."
                              : "CQ is not submitted for this training."}
                          </label>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* //////////////// PTE VIEW ////////////////// */}

            {isPte && (
              <div>
                <div className="row">
                  {this.state.PTE?.length > 0 ? (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                      >
                        <button
                          className={` pte-label-button label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="skillKonwIcon" />
                          <span className="pl-5 properties-span-2">
                            Skill and Knowledge Evaluation
                          </span>
                        </button>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div
                          className={` table-responsive table-responsive-scroll `}
                        >
                          <table className="postskill-table-width">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" slno text-12-bold border-right border-left">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Capability & knowledge
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Level of capability and knowledge (Pre-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-left border-right pl-5px">
                                  Level of capability and knowledge (Post-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-left border-right pl-5px">
                                  Level of capability and knowledge
                                  (Post-Training-further)
                                </th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom text-12-normal-400">
                              {this.state.PTE?.length > 0 ? (
                                this.state.PTE.map((item, index) => (
                                  <tr
                                    key={index + "PTE"}
                                    className={`${this.state.PTE?.length !== index + 1 &&
                                      "border-bottom"
                                      } `}
                                  >
                                    <td className=" text-12-bold border-right border-left pl-10 pb-80">
                                      {index + 1}
                                    </td>

                                    <td className="mt-2 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box2 resize-none border-radius-0 border-none color-white w-100 `}
                                        rows="3"
                                        value={item.question}
                                        readOnly={true}
                                        disabled={true}
                                      // disabled={true}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={` pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteAnswersOption?.map(
                                        (pteOption1, index) => (
                                          <>
                                            <input
                                              className={`height ${pteOption1?.id ===
                                                item?.ptE1AnswerId &&
                                                "color-black"
                                                }`}
                                              type="radio"
                                              // name={"test" + item.questionId + "pte1"}
                                              disabled={
                                                pteOption1?.id !==
                                                item?.ptE1AnswerId
                                              }
                                              checked={
                                                pteOption1?.id ===
                                                item?.ptE1AnswerId
                                              }
                                            />
                                            <label
                                              className={`${isMobile ? "pl-3" : "pl-10"
                                                }`}
                                            >
                                              {pteOption1?.name}
                                            </label>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE2AnswerId ? (
                                        <>
                                          {this.state.pteAnswersOption?.map(
                                            (pteOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteOption?.id ===
                                                    item?.ptE2AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + item.questionId + "pte2"}
                                                  disabled={
                                                    pteOption?.id !==
                                                    item?.ptE2AnswerId
                                                  }
                                                  checked={
                                                    pteOption?.id ===
                                                    item?.ptE2AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.PTE?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                {this.state.pendingApprovalsView.pteStatus?.toLowerCase() ===
                                                  "pte not applicable"
                                                  ? "PTE is not applicable for this training."
                                                  : "PTE is not submitted for this training."}
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE3AnswerId ? (
                                        <>
                                          {this.state.pteAnswersOption?.map(
                                            (pteOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteOption?.id ===
                                                    item?.ptE3AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + item.questionId + "pte3"}
                                                  disabled={
                                                    pteOption?.id !==
                                                    item?.ptE3AnswerId
                                                  }
                                                  checked={
                                                    pteOption?.id ===
                                                    item?.ptE3AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.PTE?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE 3 is not submitted for this
                                                training
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td
                                    colSpan={7}
                                    className="table-nodata text-center border-right p-2"
                                  >
                                    {"No record found"}
                                  </td>
                                </tr>
                              )}
                              <tr className="border-right border-left">
                                <td></td>
                                <td className="border-right border-left"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                      >
                        <button
                          className={`pte-label-button label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="jobIcon" />
                          <span className="pl-5 properties-span-2">
                            List of Job/Task/Activity Undertake After Completing
                            Training
                          </span>
                        </button>
                      </div>

                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div
                          className={`table-responsive table-responsive-scroll mt-20`}
                        >
                          <table className="pte-table-width text-12-normal-400">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" skill-slno text-12-bold border-right border-left">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Job / Task / Activity
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Pre-Training)
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Post-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Post-Training-further)
                                </th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom">
                              {this.state.pteJob?.length > 0 ? (
                                this.state.pteJob?.map((item, index) => (
                                  <tr
                                    key={index + "PTEJOB"}
                                    className={`${this.state.pteJob?.length !== index + 1 &&
                                      "border-bottom"
                                      } `}
                                  >
                                    <td className="mt-1 text-12-bold border-right border-left pl-10 pb-50">
                                      {index + 1}
                                    </td>
                                    <td className="mt-2 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box3 border-none resize-none border-radius-0 border-none color-white w-100 `}
                                        rows="3"
                                        value={item.question}
                                        // readOnly = {this.state.isPteSubmit}
                                        disabled={true}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteJobAnswerOption?.map(
                                        (pteJobOption, index) => (
                                          <>
                                            <input
                                              className={`height ${pteJobOption?.id ===
                                                item?.ptE1AnswerId &&
                                                "color-black"
                                                }`}
                                              type="radio"
                                              // name={"test" + item.questionId + "ptejob1"}
                                              disabled={
                                                pteJobOption?.id !==
                                                item?.ptE1AnswerId
                                              }
                                              checked={
                                                pteJobOption?.id ===
                                                item?.ptE1AnswerId
                                              }
                                            />
                                            <label
                                              className={`${isMobile ? "pl-3" : "pl-10"
                                                }`}
                                            >
                                              {pteJobOption?.name}
                                            </label>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE2AnswerId ? (
                                        <>
                                          {this.state.pteJobAnswerOption?.map(
                                            (pteJobOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteJobOption?.id ===
                                                    item?.ptE2AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + item.questionId + "ptejob2"}
                                                  disabled={
                                                    pteJobOption?.id !==
                                                    item?.ptE2AnswerId
                                                  }
                                                  checked={
                                                    pteJobOption?.id ===
                                                    item?.ptE2AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteJobOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}{" "}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.pteJob?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE is Not submitted for this
                                                training
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE3AnswerId ? (
                                        <>
                                          {this.state.pteJobAnswerOption?.map(
                                            (pteJobOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteJobOption?.id ===
                                                    item?.ptE3AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + item.questionId + "ptejob3"}
                                                  disabled={
                                                    pteJobOption?.id !==
                                                    item?.ptE3AnswerId
                                                  }
                                                  checked={
                                                    pteJobOption?.id ===
                                                    item?.ptE3AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteJobOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}{" "}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.pteJob?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE 3 is not submitted for this
                                                training
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td className="table-nodata text-center border-right border-left p-2">
                                    No record found
                                  </td>
                                  <td></td>
                                  <td className="border-right"></td>
                                </tr>
                              )}
                              {/* <tr>
                                              <td></td>
                                              <td>
                                                {jobEmptyId?.length > 0 ? (
                                                  <span className="send-rework-label">
                                                    All field is required
                                                  </span>
                                                ) : (
                                                  <></>
                                                )}
                                              </td>
                                            </tr> */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <>
                        <div className="text-center mt-3">
                          <label className="text-16-normal fw-bold text-color-red">
                            PTE is not submitted for this training.
                          </label>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {
          // <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="cancelrequestScreen1" aria-labelledby="offcanvasScrollingLabel">
          //   <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
          //     <h6 id="offcanvasRightLabel" className="modal-title fw-600">{pendingApprovalsView.currentStatus ? pendingApprovalsView.currentStatus : "-"}</h6>
          //     <button className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""}`} onClick={this.closeProperties}>
          //       <CommonIcon fileName="CrossIcon" />
          //     </button>
          //   </div>
          //   <div className="offcanvas-body px-4 pt-0" id="myRequestBody">
          //     <div className="row mt-3">
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"}`}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="requestId" />
          //             {" "}<span className="pl-5 text-12-bold">Request ID</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //             {pendingApprovalsView.trainingRequestId ? pendingApprovalsView.trainingRequestId : "-"}</label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"}`}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="ContactPersonIcon" />
          //             <span className="pl-5 text-12-bold">Employee name</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //             {pendingApprovalsView.employeeName ? pendingApprovalsView.employeeName : "-"}
          //           </label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"}`}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="EmployeeCodeIcon" />
          //             <span className="pl-5 text-12-bold">Employee code</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //             {pendingApprovalsView.employeeCode ? pendingApprovalsView.employeeCode : "-"}
          //           </label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"}`}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="CourseCodeIcon" />
          //             <span className="pl-7 text-12-bold">Course code</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //             {pendingApprovalsView.courseCode ? pendingApprovalsView.courseCode : "-"}
          //           </label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             {/* <CommonIcon fileName="CourseTitleIcon" /> */}
          //             <div className="mt-3px"><CommonIcon fileName="CourseTitleIcon" /></div>
          //             {" "}<span className="pl-7 text-12-bold">Course title</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //             {pendingApprovalsView.courseTitle ? pendingApprovalsView.courseTitle : "-"}</label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"}`}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="RequestedByIcon" />
          //             {" "}<span className="pl-7 text-12-bold">Requested for</span>&nbsp;
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>{pendingApprovalsView.requestedBy ? pendingApprovalsView.requestedBy : "-"}</label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="DateIcon" />
          //             {" "}<span className="pl-5 text-12-bold">Requested date</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //             {pendingApprovalsView.requestedDate
          //               ? moment(pendingApprovalsView.requestedDate).format(
          //                 "DD-MMM-YYYY"
          //               )
          //               : ""}
          //           </label>
          //         </div>
          //       </div>
          //       <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
          //         <div className="form-group">
          //           <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //             <CommonIcon fileName="PropertiesIcon" />
          //             {" "} <span className="pl-5 text-12-bold">Current status</span>
          //           </label>
          //           <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>{pendingApprovalsView.currentStatus || "-"}</label>
          //         </div>
          //       </div>
          //       <>
          //         <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
          //           <div className="form-group">
          //             <label
          //               className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //               <CommonIcon fileName="trainingbondicon" className="properties-img" />
          //               <span className="pl-10 text-12-bold">Training bond</span>
          //             </label>
          //             {pendingApprovalsView.trainingBond ?
          //               <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
          //                 <a className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`} onClick={() => this.handleFilesOpen("TrainingBond")} target="_blank">
          //                   <FileIcon fileName={pendingApprovalsView.trainingBond.fileName} className="documentFile" />
          //                   <span className="pl-7 text-center urlspan">{pendingApprovalsView.trainingBond.fileName ? pendingApprovalsView.trainingBond.fileName : "-"}</span>
          //                 </a>
          //               </div> : (<><div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
          //                 <label className="table-noversion" > - </label>
          //               </div></>)}
          //           </div>
          //         </div>
          //       </>
          //       {(pendingStatus === UserStatus.PENDING_FOR_CERT || pendingStatus === UserStatus.TRAINING_COMPLETED || pendingStatus === UserStatus.TRAINING_CANCELLED) &&
          //         <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
          //           <div className="form-group">
          //             <label
          //               className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //               <CommonIcon fileName="certificateCourseCatalogue" className="properties-img" />
          //               <span className="pl-10 text-12-bold">Certificate</span>
          //             </label>
          //             {pendingApprovalsView.certificate ?
          //               <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
          //                 <a className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`} onClick={() => this.handleFilesOpen("Certificate")} target="_blank">
          //                   <FileIcon fileName={pendingApprovalsView.certificate.fileName} className="documentFile" />
          //                   <span className="pl-7 text-center urlspan">{pendingApprovalsView.certificate.fileName ? pendingApprovalsView.certificate.fileName : "-"}</span>
          //                 </a>
          //               </div> : (<><div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-0">
          //                 <label className="table-noversion" > - </label>
          //               </div></>)}
          //           </div>
          //         </div>
          //       }
          //       {pendingStatus?.toLowerCase()?.replace(/\s+/g, '') === UserStatus.PENDING_FOR_CERT && <>
          //         <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isMobile ? "" : "pb-3"} `}>
          //           <div className="form-group">
          //             <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //               <CommonIcon fileName="DateIcon" />
          //               <span className="pl-5 text-12-bold">Expiry date</span>
          //             </label>
          //             <label className={`text-12-normal-400 ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
          //               {pendingApprovalsView.certificateExpiryDate
          //                 ? moment(pendingApprovalsView.certificateExpiryDate).format(
          //                   "DD-MMM-YYYY"
          //                 )
          //                 : ""}
          //             </label>
          //           </div>
          //         </div>
          //       </>
          //       }
          //       {
          //         ((pendingStatus === UserStatus.TRAINING_COMPLETED) || (pendingStatus === UserStatus.TRAINING_CANCELLED) || (pendingStatus === UserStatus.TRAINING_REJECTED) || (currentUser === UserRole.SUPERVISOR) || (currentUser === UserRole.EMPLOYEE) || (currentUser === UserRole.MANAGER) || (currentUser === UserRole.GM))
          //           ? <></>
          //           :
          //           (<div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pb-3 mt-1`}>
          //             <div className="form-group">
          //               <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //                 <CommonIcon fileName="CommentIcon" />
          //                 <span className="pl-5 text-12-bold">Comments</span>
          //               </label>
          //               <textarea className={`form-control border-radius shiptype-select mt-2 comments-style text-12-bold`} onChange={this.handleTBondComments} style={{ borderColor: validateComments ? "#d12232" : "" }} value={CancelRequestComments} ref={this.focusRef} />
          //             </div>
          //           </div>)
          //       }
          //       {
          //         ((pendingStatus === UserStatus.TRAINING_COMPLETED) || (pendingStatus === UserStatus.TRAINING_CANCELLED) || (pendingStatus === UserStatus.TRAINING_REJECTED) || (currentUser === UserRole.SUPERVISOR) || (currentUser === UserRole.EMPLOYEE) || (currentUser === UserRole.MANAGER) || (currentUser === UserRole.GM))
          //           ? <></>
          //           :
          //           <div className={`${iswebMobile ? "col-12" : "col-6"} col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-3  ${isMobile ? "mt-4" : "mt-2"}`} >
          //             <button className={`btn btn-light input-group offcavasclose filter-reworkbtn p-2`} onClick={this.handleRequest} >
          //               <CommonIcon fileName="ButtonRejectIcon" className="modal-img" />
          //               <span className="send-rework-label pl-5">
          //                 Cancel request
          //               </span>
          //             </button>
          //           </div>
          //       }
          //     </div>
          //     {/* ///////////////// History log /////////////////////// */}
          //     {
          //       (this.state.currentUser !== UserRole.EMPLOYEE) &&
          //       (<div className="row mt-1">
          //         <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}>
          //           <div className="form-group">
          //             <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
          //               <CommonIcon fileName="VersionIcon" />
          //               <span className="pl-5 properties-span">History log</span>
          //             </label>
          //             <div className="table-responsive mb-4 mt-3">
          //               <table id="historyTable">
          //                 <tbody>
          //                   {historyLogList.length !== 0 ?
          //                     historyLogList.map((i, index) => (
          //                       <><tr id={index} key={index}>
          //                         <td className="title-width fw-bold">{i.status}</td>
          //                         <td className={`history-date no-wrap ${isRadioMobile ? "date-width" : ""}`} >{i.createdDate
          //                           ? moment(new Date(Date.parse(i.createdDate))).format("DD-MMM-YYYY h:mm A")
          //                           : ""}</td>
          //                       </tr>
          //                         <tr>
          //                           <td colSpan={2} className="fw-bold">  {i.reviewer}</td>
          //                           {/* Reviewer ----- > type doubt*/}
          //                         </tr>
          //                         <tr>
          //                           <td colSpan={2} className="history-comment">{i.comments}</td>
          //                         </tr>
          //                       </>
          //                     )) :
          //                     <tr>
          //                       <td className="table-noversion" colSpan={3}>
          //                         No history log to display
          //                       </td>
          //                     </tr>}
          //                 </tbody>
          //               </table>
          //             </div>
          //           </div>
          //         </div>
          //       </div>)
          //     }
          //   </div>
          // </div>
        }

        {/*               Search Screen                */}

        {
          <div
            className={` viewbar-search viewbarOpen visible-hide`}
            id="searchScreen"
          >
            <div className="viewMain">
              <div className="viewTitle mb-2 px-4 pt-4">
                <h6 id="offcanvasRightLabel" className="modal-title head-span">
                  Search
                </h6>
                <button
                  className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : "pr-0"
                    }`}
                  onClick={() => this.closeProperties()}
                >
                  <CommonIcon fileName="CrossIcon" />
                </button>{" "}
              </div>

              <div className="px-4 pt-0">
                <div className="row">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="requestId" />
                        <span className="pl-5 properties-span-2">
                          Request ID
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box-search  records-editinput-class "
                        value={this.state.searchInputData.trainingRequestId}
                        onChange={(e) =>
                          this.handleInputchange(e, "trainingRequestId")
                        }
                        required
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="CourseCodeIcon" />
                        <span className="pl-5 properties-span-2">
                          Course code
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-text-box-search  records-editinput-class"
                        value={this.state.searchInputData.courseCode}
                        onChange={(e) =>
                          this.handleInputchange(e, "courseCode")
                        }
                        required
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-1 ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="CourseTitleIcon" />
                        <span className="pl-5 properties-span-2">
                          Course title
                        </span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.courseTitle}
                        onChange={(e) =>
                          this.handleInputchange(e, "courseTitle")
                        }
                        required
                      />
                    </div>
                  </div>

                  {this.state.currentUser !== UserRole.EMPLOYEE && (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                          }`}
                      >
                        <div className="form-group">
                          <label
                            className={`d-flex label-text mb-1 ${isMobile ? "pt-2" : ""
                              }`}
                          >
                            <CommonIcon fileName="RequestedByIcon" />
                            <span className="pl-5 properties-span-2">
                              Requested for
                            </span>
                          </label>
                          <input
                            type="text"
                            className={`form-control form-text-box-search  records-editinput-class`}
                            value={this.state.searchInputData.requestedfor}
                            onChange={(e) =>
                              this.handleInputchange(e, "requestedfor")
                            }
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-2 ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">
                          Start date
                        </span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 records-editinput-class search-date"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={<CommonIcon fileName="calenderDate" />}
                          format="dd-MMM-yyyy"
                          value={
                            this.state.searchInputData.startDate
                              ? this.state.searchInputData.startDate
                              : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleInputchange(e, "startDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-2 ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">End date</span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 records-editinput-class search-date"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={<CommonIcon fileName="calenderDate" />}
                          format="dd-MMM-yyyy"
                          value={
                            this.state.searchInputData.endDate
                              ? this.state.searchInputData.endDate
                              : null
                          }
                          size="small"
                          onChange={(e) => this.handleInputchange(e, "endDate")}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex label-text mb-2 ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="DateIcon" />
                        <span className="pl-5 properties-span-2">
                          Requested date
                        </span>
                      </label>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          inputVariant="outlined"
                          className="form-control f-12 records-editinput-class search-date"
                          emptyLabel="dd-mmm-yyyy"
                          keyboardIcon={<CommonIcon fileName="calenderDate" />}
                          format="dd-MMM-yyyy"
                          value={
                            this.state.searchInputData.requestedDate
                              ? this.state.searchInputData.requestedDate
                              : null
                          }
                          size="small"
                          onChange={(e) =>
                            this.handleInputchange(e, "requestedDate")
                          }
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="PropertiesIcon" />
                        <span className="pl-5 properties-span-2">
                          Current status
                        </span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.currentStatus}
                        onChange={(e) =>
                          this.handleInputchange(e, "currentStatus")
                        }
                        required
                      /> */}
                      <Select
                        className={`form-text-box-search searchValid`}
                        classNamePrefix="assigngroups"
                        value={this.state.currentStatus}
                        placeholder="Please select an option"
                        styles={styles}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        options={this.state.currentStatusList}
                        defaultValue={this.state.currentStatus || "Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => this.handleCurrentStatus(e)}
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="trainingbondicon" />
                        <span className="pl-5 properties-span-2">
                          Training bond status
                        </span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.trainingBondStatus}
                        onChange={(e) =>
                          this.handleInputchange(e, "trainingBondStatus")
                        }
                        required
                      /> */}
                      <Select
                        className={`form-text-box-search searchValid`}
                        classNamePrefix="assigngroups"
                        value={this.state.trainingBondStatus}
                        placeholder="Please select an option"
                        styles={styles}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        options={this.state.trainingBondstatusList}
                        defaultValue={this.state.trainingBondStatus || "Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => this.onchangeTbStatus(e)}
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="certificateCourseCatalogue" />
                        <span className="pl-5 properties-span-2">
                          Certificate status
                        </span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.certificateStatus}
                        onChange={(e) =>
                          this.handleInputchange(e, "certificateStatus")
                        }
                        required
                      /> */}
                      <Select
                        className={`form-text-box-search searchValid`}
                        classNamePrefix="assigngroups"
                        value={this.state.certificateStatus}
                        placeholder="Please select an option"
                        styles={styles}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        options={this.state.certificateStatusList}
                        defaultValue={this.state.certificateStatus || "Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => this.onchangeCertificateStatus(e)}
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="louicon" />
                        <span className="pl-5 properties-span-2">
                          LOU status
                        </span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.louStatus}
                        onChange={(e) => this.handleInputchange(e, "louStatus")}
                        required
                      /> */}
                      <Select
                        className={`form-text-box-search searchValid`}
                        classNamePrefix="assigngroups"
                        value={this.state.louStatus}
                        placeholder="Please select an option"
                        styles={styles}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        options={this.state.louStatusList}
                        defaultValue={this.state.louStatus || "Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => this.onchangeLouStatus(e)}
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="CourseQuestionIcon" />
                        <span className="pl-5 properties-span-2">
                          CQ status
                        </span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={
                          this.state.searchInputData.courseQuestionnaireStatus
                        }
                        onChange={(e) =>
                          this.handleInputchange(e, "courseQuestionnaireStatus")
                        }
                        required
                      /> */}
                      <Select
                        className={`form-text-box-search searchValid`}
                        classNamePrefix="assigngroups"
                        value={this.state.courseQuestionnaireStatus}
                        placeholder="Please select an option"
                        styles={styles}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        options={this.state.cqStatusList}
                        defaultValue={
                          this.state.courseQuestionnaireStatus || "Select"
                        }
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => this.onchangeCqStatus(e)}
                      />
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                      } ${isMobile ? "" : "pb-3"}`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon fileName="pteIcon" />
                        <span className="pl-5 properties-span-2">
                          PTE status
                        </span>
                      </label>
                      {/* <input
                        type="text"
                        className={`form-control form-text-box-search  records-editinput-class`}
                        value={this.state.searchInputData.pteStatus}
                        onChange={(e) => this.handleInputchange(e, "pteStatus")}
                        required
                      /> */}
                      <Select
                        className={`form-text-box-search searchValid`}
                        classNamePrefix="assigngroups"
                        value={this.state.pteStatus}
                        placeholder="Please select an option"
                        styles={styles}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        options={this.state.pteStatusList}
                        defaultValue={this.state.pteStatus || "Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={(e) => this.onchangePteStatus(e)}
                      />
                    </div>
                  </div>
                </div>

                {this.state.validationMsg ? (
                  <span className="properties-span-2 text-danger">
                    Atleast one field is mandatory
                  </span>
                ) : (
                  ""
                )}
                <div className="d-flex mt-20">
                  <button
                    className={`btn rejectbutton d-flex gap-1`}
                    onClick={() => this.clearSearchDetails()}
                  >
                    <span>
                      <CommonIcon fileName="clearIcon1" />
                    </span>
                    <span className="pl-vendor3 pl-2">Clear</span>
                  </button>
                  <button
                    className={`btn approvebutton d-flex gap-1 ml-10`}
                    onClick={() => this.validateSearchRecords()}
                  >
                    <span>
                      <CommonIcon fileName="searchableIcon" />
                    </span>
                    <span className="model-label pl-vendor3 pl-2">Search</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
        <WarningComponent
          message={"Are you sure you want to cancel the request?"}
          isMobile={this.state.isMobile}
          onYesClick={() => this.cancelRequest()}
        />

        {/* Pagination */}
        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={this.state.pageCount}
          reset={this.state.pageNewCount}
        />
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RequestStatus)
);
